// 首页进来---林权/农村详情
<template>
  <div v-loading='Loading'>
    <header-img :list="headerList"></header-img>
    <div class="container-main">
<!--      <div class="top-title">项目详情 </div>-->
      <div class="flex-around delete-around">
         <!-- style=" width: 408px;" -->
        <div class="el-carousel-wrap">
           <!-- height="308px" -->
          <el-carousel @change="carouselChange" ref="villageCarousel" height="372px" class="banner" indicator-position="none" arrow="always" :autoplay="false">
            <div v-if="data.imgList && data.imgList.length">
              <el-carousel-item v-for="(item, index) in data.imgList" :key="index">
                <img :src="item.imgUrl" />
              </el-carousel-item>
            </div>
            <div v-else>
              <el-carousel-item v-for="(item, index) in imgList" :key="index">
                <img src="@/assets/area/baise.png" />
              </el-carousel-item>
            </div>
            <div class="flag">
              <img :src="require(`@/assets/icon/stauts_icon/${$route.query.status}.png`)" alt="">
                <span>{{$route.query.status == 3 ? '挂牌中':$route.query.status == 4 ? '已摘牌':$route.query.status == 5 ? '未成交':$route.query.status == 6 ? '已成交':$route.query.status == 10 ? '竞拍结束':$route.query.status == 15 ? '摘牌审批中':''}}</span>
            </div>
          </el-carousel>
          <div class="mini-carousel-list">
            <div class="arrow-btn" @click="changeCarousel('prev')">&lt;</div>
            <div class="mini-carousel-box">
              <div ref='miniCarouselContent' style="margin-left: 0;" class="mini-carousel-content" v-if="data.imgList && data.imgList.length">
                <img @click="activeMiniFn(index)" v-for="(item, index) in data.imgList" :key="index" :src="item.imgUrl" :class="{'mini-active': miniActive === index}" :id="'miniImg'+index" />
              </div>
              <div class="mini-carousel-content" v-else>
                <img src="@/assets/area/baise.png" />
              </div>
            </div>
            <div class="arrow-btn" @click="changeCarousel('next')">&gt;</div>
          </div>
        </div>
        <div class="content-text">
          <div class="flex-between">
            <h2>{{data.name}}</h2>
            <div style="font-size: 12px;color: #A8AAAE;line-height: 30px;">{{data.viewNum}}次浏览</div>
          </div>
          <div class="business-type">
            <div class="title">业务类型</div>
            <div class="type">{{data.businessTypeDesc}}</div>
          </div>
          <div class="price-box-wrap">
            <div class="state-box" :class="{'red':$route.query.status == 3||$route.query.status == 6}">
              <div v-show="$route.query.status == 3">
                <img src="@/assets/icon/statuts/status02.png" alt="">
                <p>挂牌中</p>
              </div>
              <div v-show="$route.query.status == 4">
                <img src="@/assets/icon/statuts/status02.png" alt="">
                <p>已摘牌</p>
              </div>
              <div v-show="$route.query.status == 5">
                <img src="@/assets/icon/statuts/status01.png" alt="">
                <p>未成交</p>
              </div>
              <div v-show="$route.query.status == 6">
                <img src="@/assets/icon/statuts/status01.png" alt="">
                <p>已成交</p>
              </div>
              <div v-show="$route.query.status == 10">
                <img src="@/assets/icon/statuts/status03.png" alt="">
                <p>竞拍结束</p>
              </div>
              <div v-show="$route.query.status == 15">
                <img src="@/assets/icon/statuts/status02.png" alt="">
                <p>摘牌审批中</p>
              </div>
            </div>
            <div  v-if="data.tranferType == 1" :class="{'flex-between':true, 'price-box': true}" :style="{color:'#60697E', 'background-image': 'url('+priceLangUrl+')'}">
              <div>
                <div class="must price-text">{{data.amount}}</div>
                <div>起拍价格（元）</div>
              </div>
              <div>
                <div class="must price-text">{{data.maxReportAmount || '无'}}</div>
                <div>当前最高报价（元）</div>
              </div>
            </div>
            <div class="price-box02" v-if="data.tranferType != 1 && data.tranferType != 4">
              <p class="title">标的价格（元）</p>
              <p class="price">￥<span>{{data.amount}}</span></p>
            </div>
            <div class="price-box02" v-if="data.tranferType == 4">
              <p class="title">价格面议</p>
            </div>
          </div>
          <el-divider />
          <div>
            <div class="flex-start">
              <div v-if="data.tranferType != 4">
                <span>挂牌价格</span>
                <span class="must_small" v-if="data.businessType == 1 || data.businessType == 2">
                  {{data.bidType==1 ? `${data.listingPrice}元/${data.holdAreaUnit || '亩'}` : `${data.listingPrice}元/${data.holdArea}${data.holdAreaUnit || '亩'}`}}
                </span>
                <span class="must_small" v-else>
                  {{data.bidType==1 ? `${data.listingPrice}元/${data.unit}` : `${data.listingPrice}元/${data.number}${data.unit}`}}
                </span>
              </div>
              <div><span>项目编号</span> <span>{{data.projectNum ? data.projectNum : '无'}}</span></div>
            </div>
            <div class="flex-start">
              <div v-if="data.tranferType != 4"><span>交易保证金（元）</span> <span class="must_small">{{data.tranferEnsureAmount || '无'}}</span></div>
              <div><span>交易方式</span> <span>{{data.tranferType == 1 ? '竞拍': data.tranferType == 2 ? '非竞拍': data.tranferType == 3 ? '预售': data.tranferType == 4 ? '线下交易': ''}}</span></div>
            </div>
            <div class="flex-start">
              <div v-if="data.tranferType != 4"><span>预付款（元）</span> <span class="must_small">{{data.advancePaymentAmount || '无'}}</span></div>
              <div v-if="data.tranferType == 1"><span>竞价阶梯（元/次）</span> <span class="must_small">{{data.auctionInterval || '无'}}</span></div>
              <div v-else-if="data.tranferType == 4"></div>
              <div v-else><span>交易付款方式</span><span>{{data.payWay == 1?'一次性支付':data.payWay == 2?'分期支付':''}}</span></div>
            </div>
            <div class="flex-start" v-if="data.tranferType == 1">
              <div><span>交易付款方式</span><span>{{data.payWay == 1?'一次性支付':data.payWay == 2?'分期支付':''}}</span></div>
            </div>
            <el-divider />
            <div class="process-list process-show">
              <div>开始</div>
              <div :class="{'not-start-process': !finish}">结束</div>
            </div>
            <el-steps :active="finish ? 3 : 2" :class="{'finish':finish}">
              <el-step icon="el-icon-success"/>
              <!-- <el-step icon="el-icon-success" title="开始" :description="data.tranferType == 1 ? data.auctionStartTime: data.applyTime"></el-step> -->
              <el-step icon="el-step__icona"> </el-step>
              <el-step v-if="finish" icon="el-icon-remove"/>
              <el-step v-else icon="fa fa-circle"/>
              <!-- <el-step v-if="finish" icon="el-icon-remove" title="结束" :description="data.tranferType == 1 ? data.auctionEndTime: data.endTime"></el-step>
              <el-step v-else icon="fa fa-circle" title="结束" :description="data.tranferType == 1 ? data.auctionEndTime: data.endTime"></el-step> -->
            </el-steps>
            <div class="process-list">
              <div>{{data.tranferType == 1 ? data.auctionStartTime: data.applyTime}}</div>
              <div v-if="finish">{{data.tranferType == 1 ? data.auctionEndTime: data.endTime}}</div>
              <div v-else>{{data.tranferType == 1 ? data.auctionEndTime: data.endTime}}</div>
            </div>
          </div>
          <div style="text-align:center;">
            <el-button class="ApplyInvestment" :class='{disabledBtn: $route.query.status != 3}' type="primary" @click="diaShowEvt" v-if="data.tranferType == 1 || data.tranferType == 4">申请报价</el-button>
            <!--竞拍-->
            <el-button class="ApplyInvestment" :class='{disabledBtn: $route.query.status != 3}' type="primary" @click="diaShowEvt" v-else>申请摘牌</el-button>
            <!--非竞拍-->
            <div style="margin-bottom: 50px;" v-if="ruleContent">
              <el-checkbox v-model="checked"></el-checkbox>
              我已阅读并同意<el-link type="danger" :underline="false" @click="ruleDiaShow = true">《{{transactionName}}》</el-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-main mt20 village-tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane name="1">
          <span slot="label">
            <i class="el-icon-my el-icon-my-about"></i>
            标的相关
            <i class="triangle-img" v-if="activeName==1"></i>
          </span>
          <el-table :data="data.businessType == 1 ?tableDataNc: data.businessType == 2 ? tableDataLq : tableDataCustom" :span-method="!listingMainPartList.length ? beforeArrayMethod:arrayMethod" fixed="left" :show-header="false" border style="width:90%;margin: 20px auto;" :cell-class-name="tableCellClassName" size="mini">
            <el-table-column width="80px" prop="title" align="center"></el-table-column>
            <el-table-column width="80px" prop="name" align="center"></el-table-column>
            <el-table-column prop="mark" align="left">
              <template slot-scope="scope">
                <div v-if="scope.row.name =='相关资料' " style="text-align:left;">
                  <el-form class="form formRelative" label-position="left">
                    <el-row class="mt20">
                      <el-col v-for="(item) of roleFileList" :key="item.fileNameKey">
                        <div v-if="item.maxNumber == 1 && item.isShow">
                          <el-form-item :label="item.fileName" label-width="350px" style="margin-bottom: 0;" v-if="item.fileList && item.fileList.length">
                            <OneUpload style="display: inline-block; margin-left:30px;" :fileFuther="item" :showBtnFlag="'2'" />
                          </el-form-item>
                        </div>
                        <div v-if="item.maxNumber != 1 && item.isShow">
                          <el-form-item :label="`${item.fileName}`" label-width="350px" style="margin-bottom: 0;" v-if="item.fileList && item.fileList.length">
                            <ListUpload style="display: inline-block; margin-left:30px;" :fileFuther="item" />
                          </el-form-item>
                        </div>
                      </el-col>
                      <div v-for="(item,ind) of data.otherFileList" :key="ind">
                        <div v-if="item.isShow && item.fileUrl">
                          <el-form-item :label="item.fileName" label-width="350px" style="margin-bottom: 0;">
                            <OtherOneUpload style="display: inline-block; margin-left:30px;" :fileFuther="item" :showBtnFlag="'2'" :delBtn="false" />
                          </el-form-item>
                        </div>
                      </div>
                    </el-row>
                  </el-form>
                </div>
                <div v-else>{{scope.row.mark}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="value" align="left"></el-table-column>
            <el-table-column prop="marks" align="left"></el-table-column>
            <el-table-column prop="values" align="left"></el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 非竞拍的叫交易公告，竞拍的叫竞买公告。 -->
        <el-tab-pane name="2">
          <span slot="label">
            <i class="el-icon-my el-icon-my-notice"></i>
            {{data.tranferType == 1 ? '竞买公告': '交易公告'}}
            <i class="triangle-img" v-if="activeName==2"></i>
          </span>
          <el-table :data="data.bidNotice.bidNoticDetail" :span-method="arrayMethods" :show-header="false" border style="width:90%;margin: 20px auto;" :cell-class-name="tableCellClassNames" size="mini">
            <el-table-column prop="name" align="center" width="80px"></el-table-column>
            <el-table-column prop="labelName" align="center" width="150px"></el-table-column>
            <el-table-column align="center">
              <template slot-scope="scope">
                <div v-html="scope.row.value" class="html-table-wrap" style="text-align:left;width:100%;"></div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 非竞拍的就是交易记录，竞拍的就是竞买记录。 -->
        <el-tab-pane name="3" v-if="data.isShowBidInfo == 1">
          <span slot="label">
            <i class="el-icon-my el-icon-my-record"></i>
            {{data.tranferType == 1 ? '竞买记录': '交易记录'}}
            <i class="triangle-img" v-if="activeName==3"></i>
          </span>
          <el-table :data="data.transRecords" style="width:90%;margin: 20px auto;" size="mini" :header-row-class-name="'warning-header'">
            <el-table-column width="50px" label="序号" type="index" :index="index=>index+1" align="center"></el-table-column>
            <el-table-column label="竞买人" prop="name" align="center"></el-table-column>
            <el-table-column label="价格(元)" prop="amount" align="center"></el-table-column>
            <el-table-column label="时间" prop="createdTime" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label">
            <i class="el-icon-my el-icon-my-result"></i>
            交易结果公示
            <i class="triangle-img" v-if="activeName==4"></i>
          </span>
          <div v-html="data.tradeResult" class="html-table-wrap"></div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <dia :show.sync='dialogVisible' :data.sync='data' @dialogCloses="dialogVisible = false" @diaSccessEvt="diaSccessEvt"></dia>
    <Dialog :show="diaShow" @dialogClose="diaShow=false" :img="'success.png'" :title="'温馨提示'" :content="'已提交'" :btn="'返回首页'" :btn2="data.tranferType == 1 ? '查看我的竞拍':'查看我的投资'" />
    <!-- 交易规则弹框 -->
    <Dialog :show.sync="ruleDiaShow" @dialogClose="ruleDiaShow=false" :width="ruleContent.length > 1000 ? '800px': ''" :top="ruleContent.length > 1000 ? '15vh': '30vh'" :title="transactionName" :content="ruleContent" :btn="'关闭'" />
    <!-- 交易扣款温馨提示 -->
    <ruleTip :show.sync="ruleTipDiaShow" @ruleTipClose='ruleTipDiaShow= false' :transactionViolate='transactionViolate'></ruleTip>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar';
import HeaderImg from '@/components/HeaderImg';
import OneUpload from '@/components/DataUpload/OneUpload.vue';
import ListUpload from '@/components/DataUpload/ListUpload.vue';
import dia from './components/dia.vue';
import Dialog from '@/components/Dialog';
import ruleTip from './components/ruleTip.vue';
import { sessionStore } from '@/utils/data-management';
import OtherOneUpload from '@/components/DataUpload/OtherOneUpload.vue';
import priceLang from '@/assets/price-lang.png'
export default {
  components: {
    HeaderImg,
    OneUpload,
    ListUpload,
    dia,
    Dialog,
    ruleTip,
    Navbar,
    OtherOneUpload,
  },
  data() {
    return {
      priceLangUrl: priceLang,
      diaShow: false,
      dialogVisible: false,
      Loading: false,
      data: {
        bidNotice: {
          bidNoticDetail: [],
        },
        customFields:[]
      },
      headerList: [
        { name: '首页', path: '/Home' },
        { name: '产权交易', path: '' },
        { name: '项目详情' },
      ],
      roleFileList: [],
      ruleDiaShow: false,
      ruleTipDiaShow: false,
      checked: false,
      ruleContent: '',
      transactionName: '',
      transactionViolate: '',
      // imgList: [1, 2, 3], //标的图
      imgList: [1], //标的图
      miniActive: 0,
      miniCarouselBox: 460, // 轮播页宽
      miniPicture: 86, // 轮播单位页
      index: '',
      activeName: '1',
      //林权
      tableDataLq: [
        {
          title: '标的相关',
          name: '标的信息',
          mark: '标的简介',
          value: '',
        },
        {
          mark: '标的坐落所在地区',
          value: '',
        },
        {
          mark: '林地属性',
          value: '',
          marks: '占地面积',
          values: '',
        },
        {
          mark: '林木蓄积(立方米)',
          value: '',
          marks: '树种',
          values: '',
        },
        {
          mark: '转让期限',
          value: '',
          marks: '是否存在他项权利人',
          values: '',
        },
        {
          mark: '他项权利人',
          value: '',
          marks: '他项权利内容',
          values: '',
        },
        {
          name: '相关资料',
          mark: '',
        },
      ],
      //农村土地
      tableDataNc: [
        {
          title: '标的相关',
          name: '标的信息',
          mark: '标的简介',
          value: '',
        },
        {
          mark: '标的坐落所在地区',
          value: '',
          marks: '土地四至',
          values: '',
        },
        {
          mark: '承包方式',
          value: '',
          marks: '持有面积',
          values: '',
        },
        {
          mark: '转让期限',
          value: '',
          marks: '土地类型',
          values: '',
        },
        {
          mark: '用途',
          value: '',
          marks: '权属类型',
          values: '',
        },
        {
          mark: '所有权人',
          value: '',
          marks: '权证名称',
          values: '',
        },
        {
          mark: '权证年限',
          value: '',
          marks: '转出方式',
          values: '',
        },
        {
          mark: '是否属于再次转出',
          value: '',
          marks: '是否有优先受让方',
          values: '',
        },
        {
          mark: '是否存在他项权利人',
          value: '',
          marks: '他项权利人',
          values: '',
        },
        {
          mark: '他项权利内容',
          value: '',
          marks: '相关人员是否放弃优先权',
          values: '',
        },
        {
          name: '相关资料',
          mark: '',
        },
      ],
      //自定义类型？
      tableDataCustom:[
        {
          title: '标的相关',
          name: '标的信息',
          mark: '标的简介',
          value: '',
        },
        {
          mark: '标的坐落所在地区',
          value: '',
          marks: '标的数量',
          values: '',
        },
        {
          mark: '标的单位',
          value: '',
          marks: '转让期限',
          values: '',
        },
        {
          mark: '是否存在他项权利人',
          value: '',
          marks: '他项权利人',
          values: '',
        },
        {
          mark: '他项权利内容',
          value: '',
          marks: '',
          values: '',
        },
        {
          name: '相关资料',
          mark: '',
        },
      ],
      listingMainPartList:[],
      finish: false
      // beforeList:[]
    };
  },
  watch: {
    ruleTipDiaShow(newVal, oldVal) {
      if (newVal == false && oldVal == true) {
        this.dialogVisible = true;
      }
    },
  },
  methods: {
    carouselChange(next, prev) {
      let maxLength = this.data&&this.data.imgList?this.data.imgList.length:0
      if (prev != next && maxLength) {
        if (this.miniCarouselBox < maxLength*this.miniPicture) {
          let miniCarouselContent = this.$refs.miniCarouselContent
          if (miniCarouselContent) {
            let marginLeft = Number(miniCarouselContent.style.marginLeft.replace('px',''))
            if ((next+1)*this.miniPicture+marginLeft<=0) {
              miniCarouselContent.style.marginLeft = -next*this.miniPicture+'px'
            } else if ((next+1)*this.miniPicture+marginLeft>this.miniCarouselBox) {
              miniCarouselContent.style.marginLeft = this.miniCarouselBox-(next+1)*this.miniPicture+'px'
            }
          }
        }
        this.miniActive = next
      }
    },
    changeCarousel(type) {
      let villageCarousel = this.$refs.villageCarousel,
      datas = this.data
      if (datas&&datas.imgList&&datas.imgList.length&&villageCarousel) {
        let miniCarouselContent = this.$refs.miniCarouselContent
        if (type == 'next') {
          let maxLength = datas.imgList.length*this.miniPicture
          if(miniCarouselContent&&(maxLength>this.miniCarouselBox)) {
            let marginLeft = Number(miniCarouselContent.style.marginLeft.replace('px',''))
            if (marginLeft+maxLength > this.miniCarouselBox) {
              let moreLength = marginLeft+maxLength-this.miniCarouselBox
              miniCarouselContent.style.marginLeft = marginLeft-(moreLength >= this.miniPicture?this.miniPicture:moreLength)+'px'
            }
          }
          if (this.miniActive != datas.imgList.length - 1) {
            this.miniActive += 1
            villageCarousel.next()
          }
          // this.miniActive = (this.miniActive == datas.imgList.length - 1)?0:(this.miniActive+1)
          // villageCarousel.next()
        } else {
          if(miniCarouselContent) {
            let marginLeft = Number(miniCarouselContent.style.marginLeft.replace('px',''))
            if (marginLeft!=0) {
              let moreLength = marginLeft+this.miniPicture
              miniCarouselContent.style.marginLeft = marginLeft+(moreLength <= 0?this.miniPicture:-marginLeft)+'px'
            }
          }
          if (this.miniActive) {
            this.miniActive -= 1
            villageCarousel.prev()
          }
          // this.miniActive = !this.miniActive?(datas.imgList.length-1):(this.miniActive-1)
          // villageCarousel.prev()
        }
      }
    },
    activeMiniFn(ind) {
      if (this.data&&this.data.imgList&&this.data.imgList.length) {
        let villageCarousel = this.$refs.villageCarousel
        if (villageCarousel) {
          villageCarousel.setActiveItem(ind)
        }
        this.miniActive = ind
      }
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if ( columnIndex == 0 || columnIndex == 1 || (columnIndex == 2 && rowIndex != (this.data.businessType == 2 ? this.tableDataLq.length- 1 : this.tableDataNc.length - 1)) ||columnIndex == 4 ) {
        return 'warning-row';
      }
      return '';
    },
    tableCellClassNames({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0 || columnIndex == 1) {
        return 'warning-row';
      }
      return '';
    },
    arrayMethods({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        if (rowIndex == 0) {
          return {
            rowspan: this.data.bidNotice.bidNoticDetail.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    arrayMethod({ row, column, rowIndex, columnIndex }) {
      let list = this.data.businessType == 1 ? this.tableDataNc  : this.data.businessType == 2 ? this.tableDataLq : this.tableDataCustom
      let MainPartLength = this.listingMainPartList.length
      // console.log(rowIndex,row.name,columnIndex ,"===")
      // 当前行row、当前列column、当前行号rowIndex、当前列号 columnIndex 四个属性。
      // [rowspan: 1,    //合并一行  colspan: 2  ]  //合并两列
      if (columnIndex == 0) {
        if (rowIndex == 0) {
          return [list.length,1];
        } else {
          return [0, 0];
        }
      }
      if (columnIndex == 1) {
        if (rowIndex == 0) {
          return [list.length-1-MainPartLength,1];
        } else if ( rowIndex == list.length-1-MainPartLength ) {
          return [MainPartLength, 1];
        } else if ( rowIndex == list.length-1 ) {
          return [1, 1];
        }else {
          return [0, 0];
        }
      }
      if (columnIndex == 2) {
        if (rowIndex == list.length-1 ) {
          return [1, 4];
        }
      }
      if (this.data.businessType == 2 ) {
        if (rowIndex == 1) {
          if (columnIndex == 3) {
            return [1, 3];
          } else if (columnIndex == 2) {
            return [1, 1];
          } else {
            return [0, 0];
          }
        }
      }
      if(!list[list.length-2].marks){
        if (rowIndex == list.length-2) {
          if (columnIndex == 3) {
            return [1, 3];
          } else if (columnIndex == 2) {
            return [1, 1];
          } else {
            return [0, 0];
          }
        }
      }
      if (this.data.businessType > 2 ) {
        if(!list[list.length-2-MainPartLength].marks){
          if (rowIndex == list.length-2-MainPartLength) {
          if (columnIndex == 3) {
            return [1, 3];
          } else if (columnIndex == 2) {
            return [1, 1];
          } else {
            return [0, 0];
          }
        }
        }
      }
      if (columnIndex == 3) {
        if (rowIndex == 0 ) {
          return [1, 3];
        }
      }
    },
    beforeArrayMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(rowIndex,row.name,columnIndex ,"===")
      // 当前行row、当前列column、当前行号rowIndex、当前列号columnIndex四个属性。
      // [rowspan: 1,    //合并一行  colspan: 2  ]  //合并两列
      //第一列合并总数长度行1列
      if (columnIndex == 0) {
        if (rowIndex == 0) {
          return [this.data.businessType == 1 ? this.tableDataNc.length  : this.data.businessType == 2 ? this.tableDataLq.length : this.tableDataCustom.length,1, ];
        } else {
          return [0, 0];
        }
      }
      //第2列第1行合并总数-1行1列
      if (columnIndex == 1) {
        if (rowIndex == 0) {
          return [ this.data.businessType == 1 ? this.tableDataNc.length-1  : this.data.businessType == 2 ? this.tableDataLq.length-1 : this.tableDataCustom.length-1,1];
        } else if ( rowIndex == (this.data.businessType == 1 ? this.tableDataNc.length-1  : this.data.businessType == 2 ? this.tableDataLq.length-1 : this.tableDataCustom.length-1)) {
          return [1, 1];
        } else {
          return [0, 0];
        }
      }
      //林权类型：标的坐落所在地区单元格合并1行2列
      if (this.data.businessType ==2 ) {
        if (rowIndex == 0) {
          if (columnIndex == 3) {
            return [1, 3];
          } else if (columnIndex == 2) {
            return [1, 1];
          } else {
            return [0, 0];
          }
        }
      }
      //最后一行合并一行4列
      if ( rowIndex == (this.data.businessType == 1 ? this.tableDataNc.length-1  : this.data.businessType == 2 ? this.tableDataLq.length-1 : this.tableDataCustom.length-1)) {
          if (columnIndex == 2) {
            return [1, 4];
          } else {
            return [0, 0];
          }
        }
      if(this.data.businessType > 2 ){
        if(!this.tableDataCustom[this.tableDataCustom.length-2].marks){
          if (rowIndex == this.tableDataCustom.length-2) {
            if (columnIndex == 3) {
              return [1, 3];
            } else if (columnIndex == 2) {
              return [1, 1];
            } else {
              return [0, 0];
            }
          }
        }
      }
    },
    async getRule() {
      this.Loading = true;
      await this.$api.my.RuleDetail({ areaConfigId: this.$store.state.cityArea.areaConfigId }).then((res) => {
        if (res.code == 1000 && res.data) {
          this.ruleContent = res.data.transactionContent || '';
          this.transactionViolate = res.data.transactionViolate || '';
          this.transactionName = res.data.transactionName || '';
        }
      }).finally(() => (this.Loading = false));
    },
    diaShowEvt() {
      if (this.$route.query.status != 3) return false;
      if (!this.$store.state.token || this.$store.state.token == 'show') {
        sessionStore.remove('zctToken');
        this.$store.dispatch('getToken', 'show');
        this.$router.push('/home');
        return;
      }
      // 未认证
      if (!this.$store.state.userInfo.personVertification) {
        return (this.$store.state.vertification = true);
      }
      if (this.ruleContent && !this.checked)
        return this.$message.error(`请阅读并勾选《${this.transactionName}》`);
      const nowDate = new Date().getTime();
      let stratDate = '';
      let endDate = '';
      if (this.data.tranferType == 1) {
        stratDate = new Date(this.data.auctionStartTime).getTime();
        endDate = new Date(this.data.auctionEndTime).getTime();
      } else {
        stratDate = new Date(this.data.applyTime).getTime();
        endDate = new Date(this.data.endTime).getTime();
      }
      if (stratDate > nowDate) return this.$message.error('时间还未开始');
      if (endDate < nowDate) return this.$message.error('时间已经结束');
      if (this.transactionViolate) {
        this.ruleTipDiaShow = true;
      } else {
        this.dialogVisible = true;
      }
    },
    // 获取项目详情
    async getProjectDetails() {
      this.Loading = true;
      await this.$api.my.delistingDetail({
          applyId: this.$route.query.id,
          type: this.$route.query.type,
        }).then((res) => {
          if (res.code == 1000) {
            sessionStore.set("paramInfo",res.data)
            this.$set(res.data.bidNotice.bidNoticDetail[0],'name',res.data.tranferType == 1 ? '竞买公告' : '交易公告');
            this.data = res.data;
            this.roleFileList = res.data.fileList;
            this.roleFileList.forEach((item) => {
              this.$set(item, 'status', true);
              this.$set(item, 'fileList', []);
              if (item.maxNumber == 1) {
                item.fileList.push({
                  fileName: item.fileName,
                  fileUrl: item.fileUrl ? item.fileUrl[0] : '',
                  fileType: item.fileType,
                });
              } else {
                item.fileUrl.forEach((i) => {
                  item.fileList.push({
                    fileName: item.fileName,
                    fileUrl: i ? i : '',
                    fileType: item.fileType,
                  });
                });
              }
            });
            let arr = []
            if(this.data.listingMainPart && this.data.listingMainPart.identityType){
              let data = JSON.parse(JSON.stringify(this.data.listingMainPart))
              Object.keys(data).forEach((key,item) => {
                if (data[key]) {
                  if(key == 'name'){
                    if (data.identityType == 1) {
                      arr.push({fieldValue: data[key],fieldName:'企业'})
                    } else if (data.identityType == 2) {
                      arr.push({fieldValue: data[key],fieldName:'组织'})
                    }else if (data.identityType == 4) { // 行政事业单位
                      arr.push({fieldValue: data[key],fieldName:'单位名称'})
                    } else {
                      arr.push({fieldValue: `${data[key].substr(0, 1)}**`,fieldName:'个人'})
                    }
                  } else if (key == 'creditCode'){
                    arr.push({fieldValue: `${data[key].substr(0, 4)}**********${data[key].substr(-4)}`, fieldName: '统一信用代码'})
                  }else if (key == 'registAddrss'){
                    if(data.identityType == 4){ // 行政事业单位
                      arr.push({ fieldValue: data[key],fieldName: '住所'})
                    }else{
                      arr.push({ fieldValue: data[key],fieldName: '注册地址'})
                    }
                  }else if (key == 'legalName'){
                    if(data.identityType == 4){ // 行政事业单位
                      arr.push({fieldValue: `${data[key].substr(0, 1)}**`, fieldName: '代表人'})
                    }else{
                      arr.push({fieldValue: `${data[key].substr(0, 1)}**`, fieldName: '法定代表人'})
                    }
                  }else if (key == 'contactPerson'){
                    arr.push({fieldValue: `${data[key].substr(0, 1)}**`,fieldName: '联系人' })
                  }else if (key == 'contactNumber'){
                    arr.push({fieldValue: `${data[key].substr(0, 3)}****${data[key].substr(-4)}`,fieldName: '联系电话' })
                  }else if (key == 'contactAddress'){
                    arr.push({fieldValue: data[key], fieldName: '联系地址' })
                  } else if (key == 'idNumber'){
                    arr.push({fieldValue: `${data[key].substr(0, 4)}**********${data[key].substr(-4)}`, fieldName: '身份证号' })
                  }else{}
                }
              });
              arr.forEach((item,index) => {
                if(index % 2 === 0 ){
                  if(index == 0 ){
                    this.listingMainPartList.push({ name: '主体信息',mark: '', value: '', marks: '', values: ''})
                  } else {
                    this.listingMainPartList.push({mark: '', value: '', marks: '', values: ''})
                  }
                  this.listingMainPartList[this.listingMainPartList.length-1].mark = item.fieldName
                  this.listingMainPartList[this.listingMainPartList.length-1].value = item.fieldValue
                } else {
                  this.listingMainPartList[this.listingMainPartList.length-1].marks = item.fieldName
                  this.listingMainPartList[this.listingMainPartList.length-1].values = item.fieldValue
                }
              })
            }
            if (this.data.businessType == 1) {
              this.tableDataNc.forEach((item) => {
                if (item.mark == '标的坐落所在地区')  item.value = res.data.location;
                if (item.marks == '土地四至') item.values = res.data.fourSide;
                if (item.mark == '承包方式') item.value = res.data.contractingMode == '其他' ? res.data.otherContractingMode : res.data.contractingMode;
                if (item.marks == '持有面积')item.values = res.data.holdArea + (res.data.holdAreaUnit ? res.data.holdAreaUnit:'亩');
                if (item.mark == '转让期限') item.value = res.data.transferPeriod;
                if (item.marks == '土地类型') item.values = res.data.landType;
                if (item.mark == '用途') item.value = res.data.usePurpose;
                if (item.marks == '权属类型')
                  item.values = res.data.ownershipType;
                if (item.mark == '所有权人') item.value = res.data.owner;
                if (item.marks == '权证名称')
                  item.values = res.data.warrantName;
                if (item.mark == '权证年限') item.value = res.data.warrantTerm;
                if (item.marks == '转出方式')
                  item.values = res.data.transferMethod;
                if (item.mark == '是否属于再次转出')
                  item.value = res.data.isReTransfer == 1 ? '是' : '否';
                if (item.marks == '是否有优先受让方')
                  item.values = res.data.isPriorTransfer == 1 ? '是' : '否';
                if (item.mark == '是否存在他项权利人')
                  item.value = res.data.isOtherRightsHolder == 1 ? '是' : '否';
                if (item.marks == '他项权利人')
                  item.values = res.data.otherRightsHolder;
                if (item.mark == '他项权利内容')
                  item.value = res.data.otherRightsContent;
                if (item.marks == '相关人员是否放弃优先权')
                  item.values = res.data.isGiveUpAdvanceRight == 1 ? '是' : '否';
                if (item.mark == '标的简介')
                  item.value = res.data.describe;
              });
             if(this.listingMainPartList.length) this.tableDataNc.splice(this.tableDataNc.length-1, 0 ,...this.listingMainPartList )
            } else if (this.data.businessType == 2) {
              this.tableDataLq.forEach((item) => {
                if (item.mark == '标的坐落所在地区') item.value = res.data.location;
                if (item.mark == '林地属性')
                  item.value = res.data.forestAttr == 1 ? '国有' : res.data.forestAttr == 2 ? '非国有' : '';
                if (item.marks == '占地面积') item.values = res.data.holdArea + (res.data.holdAreaUnit ? res.data.holdAreaUnit:'亩');;
                if (item.mark == '林木蓄积(立方米)') item.value = res.data.forestStock;
                if (item.marks == '树种') item.values = res.data.treeType;
                if (item.mark == '转让期限')
                  item.value = res.data.transferPeriod;
                if (item.marks == '是否存在他项权利人')
                  item.values = res.data.isOtherRightsHolder == 1 ? '是' : '否';
                if (item.mark == '他项权利人')
                  item.value = res.data.otherRightsHolder;
                if (item.marks == '他项权利内容')
                  item.values = res.data.otherRightsContent;
                if (item.mark == '标的简介')
                  item.value = res.data.describe;
              });
              if(this.listingMainPartList.length)this.tableDataLq.splice(this.tableDataLq.length-1, 0 ,...this.listingMainPartList )
            } else {
              this.tableDataCustom.forEach((item) => {
                if (item.mark == '标的坐落所在地区') item.value = res.data.location;
                if (item.marks == '标的数量') item.values = res.data.number;
                if (item.mark == '标的单位') item.value = res.data.unit;
                if (item.marks == '转让期限') item.values = res.data.transferPeriod;
                if (item.mark == '是否存在他项权利人') item.value = res.data.isOtherRightsHolder == 1 ? '是' : '否';
                if (item.marks == '他项权利人') item.values = res.data.otherRightsHolder;
                if (item.mark == '他项权利内容') item.value = res.data.otherRightsContent;
                if (item.mark == '标的简介')
                  item.value = res.data.describe;
              });
              if(this.data.customFields){
                this.data.customFields.forEach((item,index) =>{
                  if(index % 2 === 0 ){
                    this.tableDataCustom[this.tableDataCustom.length-2].marks = item.fieldName
                    this.tableDataCustom[this.tableDataCustom.length-2].values = item.fieldValue
                  } else {
                    this.tableDataCustom.splice(this.tableDataCustom.length-1, 0 , {mark: '', value: '', marks: '', values: ''} )
                    this.tableDataCustom[this.tableDataCustom.length-2].mark = item.fieldName
                    this.tableDataCustom[this.tableDataCustom.length-2].value = item.fieldValue
                  }
                })
              }
              if(this.listingMainPartList.length)this.tableDataCustom.splice(this.tableDataCustom.length-1, 0 ,...this.listingMainPartList )
            }
            let endDate = null
            if (this.data.tranferType == 1) {
              if (isNaN(Date.parse(this.data.auctionEndTime))) {
                endDate = new Date(this.data.auctionEndTime.replace(/-/g,"/")).getTime()
              } else {
                endDate = new Date(this.data.auctionEndTime).getTime()
              }
            } else {
              if (isNaN(Date.parse(this.data.auctionEndTime))) {
                endDate = new Date(this.data.endTime.replace(/-/g,"/")).getTime()
              } else {
                endDate = new Date(this.data.endTime).getTime()
              }
            }
            let nowDate = new Date().getTime();
            if (endDate < nowDate) {
              this.finish = true
            }
          }
        }).catch((error) => {}).finally(() => {
          this.Loading = false;
        });
    },
    diaSccessEvt() {
      this.dialogVisible = false;
      this.diaShow = true;
    },
    dialogSumbitL() {
      if (this.diaShow) {
        this.dialogVisible = false;
        this.diaShow = false;
        this.$router.push({ name: 'Home' });
      } else {
        this.ruleDiaShow = false;
      }
    },
    dialogSumbitR() {
      this.dialogVisible = false;
      this.diaShow = false;
      if (this.data.tranferType == 1) {
        this.$router.push({ name: 'myAuction' });
      } else {
        this.$router.push({ name: 'myInvest' });
      }
    },
  },
  async mounted() {
    this.index = this.$route.query.index;
    this.headerList[1].path = `/Subnav/exchange-project?index=${this.index}`;
    window.scrollTo(0, 0);
    await this.getProjectDetails();
    await this.getRule();
  },
};
</script>
<style lang="scss">
.price-box02{
  background-image:url(~@/assets/price-lang.png);
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  .title{
    font-size: 14px;
    color: #666666;
    margin-left: 13px;
    margin-right: 12px;
  }
  .price{
    font-size: 16px;
    color: #F44336;
    margin: 10px 0;
    span{
      font-size: 30px;
    }
  }
}
.price-box-wrap{
  display: flex;
  flex-direction: row;
  .state-box{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #636363;
    &.red{
      background-color: #C42735;
    }
    &>div{
      display: flex;
      flex-direction: row;
      align-items: center;
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    width: 116px;
    font-size: 16px;
    color: #fff;
  }
}
.business-type{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 17px;
  .title{
    width: 76px;
    height: 24px;
    font-size: 14px;
    color: #60697E;
    line-height: 24px;
    background: #F5F6F6;
    text-align: center;
    border-radius: 2px;
    margin-right: 8px;
  }
  .type{
    font-size: 14px;
    color: #60697E;
    line-height: 14px;
  }
}
.warning-row {
  background: #f8f9fb !important;
}
.html-table-wrap {
  overflow: auto;
  /deep/ table {
    width: 100%;
  }
}
.warning-header {
  /deep/ th {
    font-size: 14px;
    color: #394259;
    background-color: #f8f9fb !important;
  }
}
.el-step__icona {
  background-image: url(~@/assets/processing@2x.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  display: inline-block;
}
</style>
<style lang="scss" scoped>
//轮播
.el-carousel-wrap {
  // width: 408px;
  // height: 308px;
  width: 492px;
  // height: 372px;
  /deep/ .el-carousel__arrow {
    height: 47px;
    width: 30px;
    border-radius: 0px 2px 2px 0px;
    background: rgba(0,0,0,0.50);
  }
  /deep/ .el-carousel__arrow--right {
    right: 0;
  }
  /deep/ .el-carousel__arrow--left {
    left: 0;
  }
  .banner {
    // width: 408px;
    width: 492px;
    /deep/ .el-carousel__item {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .flag {
      // width: 408px;
      width: 492px;
      height: 36px;
      line-height: 36px;
      background: rgba(0, 0, 0, 0.5);
      text-align: center;
      font-size: 14px;
      color: #fff;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 20px;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
}
.container-main {
  margin: 0 auto;
  background: #fff;
  // width: 1200px;
  width: 1170px;
  padding: 30px 60px;
  h2 {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 30px;
    color: #394259;
    margin: 0 0 5px;
    text-align: center;
  }
  .el-divider {
    background-color: #ebecef;
  }
  .flex-start {
    padding: 6px 0;
    > div {
      min-width: 45%;
      > span:first-child {
        min-width: 130px;
        text-align: left;
        display: inline-block;
        font-size: 14px;
        color: #60697e;
      }
      > span:last-child {
        font-size: 14px;
        color: #394259;
      }
    }
  }
  .must {
    font-size: 30px;
    line-height: 42px;
    color: #f65248 !important;
    font-weight: 600;
  }
  .must_small {
    color: #f65248 !important;
  }
  .el-steps {
    // width: 650px;
    margin: 10px 50px 8.6px;
    // margin: 50px auto 30px;
    .el-step {
      /deep/ .el-step__icon {
        width: 20px;
      }
      /deep/ .el-step__title {
        font-weight: 400;
        // color:#A8AAAE;
        font-size: 12px;
      }
      &:nth-of-type(1) {
        /deep/ .el-step__line {
          background-color: #f65248;
        }
      }
      &:nth-of-type(2) {
        /deep/ .el-step__line {
          background-color: #ebecef;
        }
      }
      &:nth-of-type(3) {
        /deep/ .el-step__main {
          text-align: right;
          transform: translateX(-80%);
        }
        /deep/ .is-process {
          color: #a8aaae;
        }
        /deep/ .el-step__icon {
          width: 12px;
        }
        /deep/ i {
          color: #ebecef;
        }
      }
    }
  }
  .finish {
    .el-step {
      /deep/ &:nth-of-type(3) {
        i {
          color: #f65248;
        }
      }
    }
  }
  .ApplyInvestment {
    font-size: 18px;
    width: 320px;
    height: 56px;
    margin-top: 32px;
    background: linear-gradient(
      135deg,
      rgba(255, 112, 103, 1) 0%,
      rgba(239, 81, 71, 1) 100%
    );
    border-radius: 2px;
    border: none;
  }
  /deep/ .formRelative {
    .el-form-item__content {
      position: static !important;
    }
  }
}
.price-box {
  flex:1;
  padding:12px 20px;
  .price-text {
    padding-bottom: 2.8px;
    margin: 0px;
  }
}
.process-list {
  display: flex;
  justify-content: space-between;
  &>div {
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #A8AAAE;
    letter-spacing: 0;
    line-height: 10px;
  }
}
.process-show {
  margin: 18.6px 34px 0;
  &>div {
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 28px;
    background: #F65248;
    border-radius: 14px;
    padding: 0 16px;
  }
  .not-start-process {
    color: #A7A7A7;
    border: 1px solid #A7A7A7;
    border-radius: 14px;
    background: white;
  }
}
.delete-around {
  justify-content: start;
}
.content-text {
  padding-left: 60px;
  flex: auto;
}
.mini-carousel-list {
  margin-top: 10px;
  display: flex;
  height: 80px;
  .arrow-btn {
    cursor: pointer;
    background: #E9EAEB;
    border: 1px solid #C2C2C2;
    color: #C2C2C2;
    text-align: center;
    line-height: 78px;
    width: 14px;
    flex: none;
  }
  .mini-carousel-box {
    flex: auto;
    overflow: hidden;
    height: 80px;
  }
  .mini-carousel-content {
    display: flex;
    height: 100%;
    flex-wrap: nowrap;
    img {
      flex: none;
      box-sizing: border-box;
      margin-left: 6px;
      cursor: pointer;
      width: 80px;
      height: 80px;
    }
    .mini-active {
      border: 2px solid #FF7067;
    }
  }
}
.el-divider--horizontal {
  margin:18px 0;
}
.village-tabs {
  /deep/ .el-tabs__item{
    &>span{
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #60697E;
      letter-spacing: 0;
    }
  }
  .el-icon-my {
    margin-right: 6.9px;
  }
  .el-icon-my:before{
    content: "\e611";
    font-size: 16px;
    visibility: hidden;
  }
  .el-icon-my-about{
    background: url("~@/assets/icon/tabs_a.png") center no-repeat;
    background-size: cover;
  }
  .el-icon-my-notice {
    background: url("~@/assets/icon/tabs_b.png") center no-repeat;
    background-size: cover;
  }
  .el-icon-my-record {
    background: url("~@/assets/icon/tabs_c.png") center no-repeat;
    background-size: cover;
  }
  .el-icon-my-result {
    background: url("~@/assets/icon/tabs_d.png") center no-repeat;
    background-size: cover;
  }
  /deep/ .el-tabs__item.is-active {
    &>span {
      position: relative;
      color: #F65248;
      .triangle-img {
        position: absolute;
        bottom: -10px;
        left: 50%;
        width: 0;
        height: 0;
        border-bottom: 6px solid #F65248;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
      }
    }
    .el-icon-my-about{
      background: url("~@/assets/icon/tabs_a_active.png") center no-repeat;
      background-size: cover;
    }
    .el-icon-my-notice {
      background: url("~@/assets/icon/tabs_b_active.png") center no-repeat;
      background-size: cover;
    }
    .el-icon-my-record {
      background: url("~@/assets/icon/tabs_c_active.png") center no-repeat;
      background-size: cover;
    }
    .el-icon-my-result {
      background: url("~@/assets/icon/tabs_d_active.png") center no-repeat;
      background-size: cover;
    }
  }
}
</style>
